/**
 * 承認の判断 2 値。取り消しは行を消すのではなく `rejected` を積む。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 承認対象（用語・Epic・Actor）の変更の承認判断（承認 / 却下）の allowlist
 * @graph-connects none
 */
export const TERM_APPROVAL_DECISIONS = ['approved', 'rejected'];
//# sourceMappingURL=term-approval.js.map